import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { TherapistInvitation } from "../schemas/invitations";

export const usePutResendTherapistInvitation = () => {
  const client = useApiClient();

  return useMutation<TherapistInvitation, Error, number>({
    mutationFn: args => client.putResendTherapistInvitation(args),
  });
};
